<template>
  <div>
    <div class="zoom-image" v-if="zoomSrc" @click="zoomSrc = ''">
      <img width="25%" :src="zoomSrc" />
    </div>
    <vueper-slides
      class="no-shadow"
      :bullets="false"
      :visible-slides="4"
      slide-multiple
      :gap="3"
      :slide-ratio="1 / 4"
      :dragging-distance="200"
    >
      <vueper-slide v-for="(item, i) in capturedScreenshots" :key="i">
        <template v-slot:content>
          <div class="capture-actions-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  dark
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="zoomSrc = item.dataURL"
                >
                  <v-icon dark>mdi-magnify-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("zoom") }}</span>
            </v-tooltip>
          </div>

          <div class="d-flex flex-column align-center">
            <img
              style="width: 100%; max-height: 150px; object-fit: contain"
              :src="item.dataURL"
              @click="zoomSrc = item.dataURL"
            />
            <div class="d-flex justify-space-between align-center capture-actions">
              <h3
                class="c-black carousel-label"
                style="color: rgb(111, 111, 111) !important"
              >
                {{ item.label }}
              </h3>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="#bbbbbb"
                      dark
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="onClickDelete(item)"
                    >
                      <v-icon dark class="carousel-icon">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("delete") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      :color="item.checked ? 'success' : '#bbbbbb'"
                      dark
                      icon
                      @click="item.checked = !item.checked"
                    >
                      <v-icon dark class="carousel-icon"
                        >mdi-checkbox-marked-circle</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>{{ item.checked ? $t("checked") : $t("check") }}</span>
                </v-tooltip>
              </div>
            </div>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>
<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
export default {
  name: "Carousel",
  mixins: [],
  components: { VueperSlides, VueperSlide },
  props: {
    capturedScreenshots: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      currentOffset: 0,
      windowSize: 3,
      paginationFactor: 150,
      zoomSrc: ""
    };
  },
  computed: {
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor *
          -1 *
          (this.capturedScreenshots.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    }
  },
  methods: {
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    onClickDelete(item) {
      this.$emit("onDeleted", item);
    }
  }
};
</script>
<style lang="scss">
$vue-navy: #2c3e50;
$vue-navy-light: #3a5169;
$vue-teal: #42b883;
$vue-teal-light: #42b983;
$gray: #666a73;
$light-gray: #f8f8f8;

.v-btn {
  text-transform: none;
}

.card-carousel {
  display: flex;
  justify-content: center;
  width: 300px;

  &--overflow-container {
    overflow: hidden;
  }

  &--nav__left,
  &--nav__right {
    display: inline-block;
    width: 15px;
    height: 15px;
    padding: 10px;
    box-sizing: border-box;
    border-top: 2px solid $vue-teal;
    border-right: 2px solid $vue-teal;
    cursor: pointer;
    margin: 0 20px;
    transition: transform 150ms linear;
    &[disabled] {
      opacity: 0.2;
      border-color: black;
    }
  }

  &--nav__left {
    transform: rotate(-135deg);
    &:active {
      transform: rotate(-135deg) scale(0.9);
    }
  }

  &--nav__right {
    transform: rotate(45deg);
    &:active {
      transform: rotate(45deg) scale(0.9);
    }
  }
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);

  .card-carousel--card {
    margin: 0 10px;
    cursor: pointer;
    box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06),
      0 2px 2px 0 rgba(40, 44, 53, 0.08);
    background-color: #fff;
    border-radius: 4px;
    z-index: 3;
    margin-bottom: 2px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    img {
      vertical-align: bottom;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      transition: opacity 150ms linear;
      user-select: none;
      width: 100%;

      &:hover {
        opacity: 0.5;
      }
    }

    &--footer {
      border-top: 0;
      padding: 7px 15px;
      background-color: transparent;
      text-align: center;

      p {
        padding: 3px 0;
        margin: 0;
        margin-bottom: 2px;
        font-size: 19px;
        font-weight: 500;
        color: $vue-navy;
        user-select: none;

        &.tag {
          font-size: 11px;
          font-weight: 300;
          padding: 4px;
          background: rgba(40, 44, 53, 0.06);
          display: inline-block;
          position: relative;
          margin-left: 4px;
          color: $gray;

          &:before {
            content: "";
            float: left;
            position: absolute;
            top: 0;
            left: -12px;
            width: 0;
            height: 0;
            border-color: transparent rgba(40, 44, 53, 0.06) transparent
              transparent;
            border-style: solid;
            border-width: 8px 12px 12px 0;
          }
          &.secondary {
            margin-left: 0;
            border-left: 1.45px dashed white;
            &:before {
              display: none !important;
            }
          }

          &:after {
            content: "";
            position: absolute;
            top: 8px;
            left: -3px;
            float: left;
            width: 4px;
            height: 4px;
            border-radius: 2px;
            background: white;
            box-shadow: -0px -0px 0px #004977;
          }
        }
      }
    }
  }
}
.zoom-image {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.9);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}
.capture-actions {
  padding: 10% !important;
  background-color: rgb(255, 255, 255);
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
}
.capture-actions-left {
  position: absolute;
  left: 0px;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue